import { property } from '@wonderlandengine/api/decorators.js';
import { Component, Material } from '@wonderlandengine/api';
import { WheelTypes } from '../../data/configuration.js';

/**
 * Wheel Description:
 */
export class WheelDescription extends Component {
	static TypeName = 'wheel-description';

	//-----------------------------------------------------------------------------------------
	// Inspector Variables:
	//-----------------------------------------------------------------------------------------

	@property.string('')
	wheelId: string = '';

	@property.material()
	paintMaterial: Material | null = null;

	@property.enum([WheelTypes[WheelTypes.Superlite], WheelTypes[WheelTypes.Multispoke], WheelTypes[WheelTypes.Aerolite], WheelTypes[WheelTypes.Sportlite]])
	wheelType!: WheelTypes;
}
